module.exports = __webpack_public_path__ + "img/c8589fb3-26ee-4ea2-b5fe-78a53f7f0dfa.5c7a114f.jpg";